
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11.5 11.39"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f8bf13","d":"M4.78 11.39l3.02-1.1.43-.15a5.275 5.275 0 003.27-4.87C11.5 2.36 9.15 0 6.24 0c-2.25 0-4.17 1.42-4.9 3.41h-.01L.01 6.78l2.06-.93-.58 1.61L.1 11.28l3.85-1.29 1.66-.56-.82 1.96z"}}),_c('path',{attrs:{"fill":"#ce952e","d":"M5.83 8l1.51-.55.22-.08A2.66 2.66 0 009.2 4.93c0-1.46-1.18-2.65-2.64-2.65-1.13 0-2.09.71-2.46 1.71l-.66 1.69 1.03-.47-.29.81-.69 1.92 1.93-.65.83-.28-.41.98z"}})])
          )
        }
      }
    